export const storageHelper = {
  session: {
    store: (key: string, value: any) => {
      let jsonString = JSON.stringify(value);
      sessionStorage.setItem(key, jsonString);
      return 1;
    },
    get: (key: string) => {
      let value = JSON.parse(sessionStorage.getItem(key)!);
      return value ?? null;
    },
    remove: (key: string) => {
      sessionStorage.removeItem(key);
      return 1;
    },
    clear: () => {
      sessionStorage.clear();
      return 1;
    }
  },

  local: {
    notify: (action: string, key?: string) => {
      if (typeof window === 'undefined') return;
      window.dispatchEvent(
        new CustomEvent('app-storage-changed', {
          detail: { area: 'local', action, key: key || null }
        })
      );
    },
    store: (key: string, value: any) => {
      let jsonString = JSON.stringify(value);
      localStorage.setItem(key, jsonString);
      storageHelper.local.notify('store', key);
      return 1;
    },
    get: (key: string) => {
      const element = localStorage.getItem(key);
      if (!element || element == undefined || element == "undefined") return null;
      let value = JSON.parse(element!)
      return value ?? null;
    },
    remove: (key: string) => {
      localStorage.removeItem(key);
      storageHelper.local.notify('remove', key);
      return 1;
    },
    clear: () => {
      localStorage.clear();
      storageHelper.local.notify('clear');
      return 1;
    }
  }
}
